import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import tr from './locales/tr.json';

const savedLanguage = localStorage.getItem('freelancehub_language') || 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr }
    },
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'freelancehub_language',
      caches: ['localStorage']
    }
  });

export const changeLanguage = (lang) => {
  localStorage.setItem('freelancehub_language', lang);
  i18n.changeLanguage(lang);
};

export default i18n;
